import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import { async } from 'validate.js';
import axiosServiceShop from 'src/utils/axiosWOBaseUrl'; //Ye use hoga 

export const getReworkStatus = createAsyncThunk(
  '/getReworkStatus',
  async () => {
    const response = await axios.get('/GetReworkStatus');
    return response.data;
  }
);
export const getReworkStatuList = createAsyncThunk(
  '/getReworkStatuList',
  async () => {
    const response = await axios.get('/getReworkStatus');
    return response.data;
  }
);
export const getReworkStatuDetails = createAsyncThunk(
  '/getReworkStatuDetails',
  async (id) => {
    const response = await axios.get(`/GetReworkStatuDetails/${id}`);
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const getReworkDetailsByWorkCaseId = createAsyncThunk(
  '/getReworkDetailsByWorkCaseId',
  async (workCaseId) => {
    const response = await axios.get(`/GetReworkDetailsByWorkCaseId/${workCaseId}`);
    return response.data;
  }
)

export const SetTenantLocation = createAsyncThunk(

  '/SetupTenant/SetTenantLocation',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantLocation', data)
    return response.data
  }
)

export const SetTenantSiriusUserTypeForEmployee = createAsyncThunk(

  '/SetupTenant/SetTenantSiriusUserTypeForEmployee',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantSiriusUserTypeForEmployee', data)
    return response.data
  }
)

export const SetTenantDistributor = createAsyncThunk(

  '/SetupTenant/SetTenantDistributor',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantDistributor', data)
    return response.data
  }
)

export const SetTenantRetailer = createAsyncThunk(

  '/SetupTenant/SetTenantRetailer',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantRetailer', data)
    return response.data
  }
)

export const SetTenantPostcodeserviceshop = createAsyncThunk(

  '/SetupTenant/SetTenantPostcodeserviceshop',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantPostcodeserviceshop', data)
    return response.data
  }
)

export const SetTenantSiriusUserType = createAsyncThunk(

  '/SetupTenant/SetTenantSiriusUserType',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantSiriusUserType', data)
    return response.data
  }
)

export const SetTenantExchangeReason = createAsyncThunk(

  '/SetupTenant/SetTenantExchangeReason',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantExchangeReason', data)
    return response.data
  }
)
export const SetTenantRejectReason = createAsyncThunk(

  '/SetupTenant/SetTenantRejectReason',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantRejectReason', data)
    return response.data
  }
)

export const SetTenantVatRate = createAsyncThunk(

  '/SetupTenant/SetTenantVatRate',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantVatRate', data)
    return response.data
  }
)
export const SetTenantNpsTranslations = createAsyncThunk(

  '/SetupTenant/SetTenantNpsTranslations',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantNpsTranslations', data)
    return response.data
  }
)

export const SetTenantStatus = createAsyncThunk(

  '/SetupTenant/SetTenantStatus',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantStatus', data)
    return response.data
  }
)

export const SetTenantWarrantyTypes = createAsyncThunk(

  '/SetupTenant/SetTenantWarrantyTypes',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetTenantWarrantyTypes', data)
    return response.data
  }
)

export const SetStatusSteps = createAsyncThunk(

  '/SetupTenant/SetStatusSteps',
  async (data) => {
    const response = await axiosServiceShop.post('/SetupTenant/SetStatusSteps', data)
    return response.data
  }
)

export const uploadReworkStatusByConsumerPhone = createAsyncThunk(

  '/Rework/UploadReworkStatusByConsumerPhone',
  async (data) => {
    const response = await axiosServiceShop.post('/Rework/UploadReworkStatusByConsumerPhone', data)
    return response.data
  }
)


export const uploadExcelToCase = createAsyncThunk(

  '/Technician/ExcelToCase',
  async (data) => {
    const response = await axiosServiceShop.post('/Technician/ExcelToCase', data)
    return response.data
  }
)


const reworkStatuSlice = createSlice({
  name: 'reworkStatu',
  initialState: {
    loading: false,
    error: '',
    reworkStatus: [],
    reworkStatuList: [],
    reworkStatuDescriptions: [],
    SelectedAppTranslationId: 0,
    Type: '',
    reworkStatuType: 0,
    IsChecked: true,
    response: '',
    uploadResponse: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    changeType(state, action) {
      state.Type = action.payload;
      //state.rejectReasonType = state.rejectReasonList.find((m) => m.Description === state.Type).ID;
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    resetDescriptions(state) {
      state.reworkStatuDescriptions = [];
    }

  },

  extraReducers: {
    [getReworkStatus.pending]: (state) => {
      state.loading = true;
    },
    [getReworkStatus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getReworkStatus.fulfilled]: (state, action) => {
      state.reworkStatus = action.payload;
      state.loading = false;
    },
    [getReworkStatuDetails.pending]: (state) => {
      state.loading = true;
    },
    [getReworkStatuDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getReworkStatuDetails.fulfilled]: (state, action) => {
      state.reworkStatuDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: (state) => {
      state.loading = true;
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.reworkStatuDescriptions = action.payload;
      state.loading = false;
    },
    [getReworkStatuList.pending]: (state) => {
      state.loading = true;
    },
    [getReworkStatuList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getReworkStatuList.fulfilled]: (state, action) => {
      state.reworkStatuList = action.payload;
      state.loading = false;
    },
    [uploadReworkStatusByConsumerPhone.pending]: (state) => {
      state.loading = true;
    },
    [uploadReworkStatusByConsumerPhone.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [uploadReworkStatusByConsumerPhone.fulfilled]: (state, action) => {
      state.uploadResponse = action.payload;
      state.loading = false;
    }
  }
});

export const reworkStatuActions = reworkStatuSlice.actions;

export default reworkStatuSlice;
